import ResultsMap from '../parser/results-map';

export default {
  metaData: null,
  matchesData: null,
  selectedSport: null,
  filteredResults: null,
  resultsLoaded: false,
  utcDate: null,
  resultsMap: ResultsMap,
  companySettings: {
    locale: '',
    uuid: '',
  },
};
